import SelectCity, { selectCityInputLanguages } from "../../../citySelect/SelectCity"

import style from "../../../../sass/components/popups/create-shipment-popup.module.scss";
import { useEffect } from "react";

const SelectReceiverCity = ({receiverGeolocation, setReceiverGeolocation}) => {
  return (
        <SelectCity
            state={receiverGeolocation}
            setState={setReceiverGeolocation}
            initialState={null}
            selectClassName={`${style.select} col-span-8 text-xs`}
            containerClassName={"flex flex-col max-w-sm"}
            labelClassNames={"col-span-2 text-gray-600"}
            inputsClassNames={`${style.input} col-span-8 text-xs`}
            inputBlockClassNames={
                "grid items-center grid-cols-10 mb-2"
            }
            language={selectCityInputLanguages.TR}
        />
  )
}

export default SelectReceiverCity